import React from 'react';

/**
 * ============================================
 * Footer Modatex
 * ============================================
 * Footer avec design Bélanger - Style page d'accueil
 */

const Footer = () => {
    return (
        <footer className="relative bg-[#C5C0B8] min-h-screen flex flex-col overflow-hidden z-50">
            {/* Large Background Text */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-30">
                <h1 className="font-serif text-[28vw] lg:text-[32vw] font-light text-[#3D3D3D]/10 leading-none">
                    Modatex
                </h1>
            </div>

            {/* Content */}
            <div className="relative z-10 flex-1 flex flex-col justify-between max-w-7xl w-full mx-auto px-8 lg:px-12 py-16 lg:py-20">
                {/* Top Section - Social Links */}
                <div className="pt-8 lg:pt-16">
                    <h3 className="text-xl lg:text-2xl font-serif font-light text-[#3D3D3D] mb-2">
                        Suivez-nous
                    </h3>
                    <div className="w-16 h-0.5 bg-[#3D3D3D] mb-8"></div>

                    {/* Social Links Grid */}
                    <div className="grid grid-cols-2 gap-x-12 gap-y-5">
                        {/* Facebook */}
                        <a href="https://www.facebook.com/modatex.tunisie" className="flex items-center gap-3 text-[#3D3D3D] hover:opacity-70 transition-opacity group">
                            <div className="w-5 h-5 flex-shrink-0">
                                <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                            </div>
                            <span className="text-sm font-medium">Facebook</span>
                        </a>

                        {/* Instagram */}
                        <a href="https://www.instagram.com/modatex_page_officielle/" className="flex items-center gap-3 text-[#3D3D3D] hover:opacity-70 transition-opacity group">
                            <div className="w-5 h-5 flex-shrink-0">
                                <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                                </svg>
                            </div>
                            <span className="text-sm font-medium">Instagram</span>
                        </a>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-[#3D3D3D]/15 pt-8 pb-4">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
                        {/* Left - Fingerprint Icon */}
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 rounded-full border border-[#3D3D3D]/30 flex items-center justify-center">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5 text-[#3D3D3D]" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33" />
                                </svg>
                            </div>
                        </div>

                        {/* Center - Copyright */}
                        <div className="text-center">
                            <p className="text-sm text-[#3D3D3D]/70 font-medium">
                                ©2025 Tous droits réservés
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;


